
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import CustomRoutes from './routes/routes';
import { AlertsProvider } from './context/AlertsContext';

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <AlertsProvider>
          <CustomRoutes />
          <ToastContainer position="top-right" />
        </AlertsProvider>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
